import styled from "@emotion/styled";
import { api } from "@/modules/api";
import { useMutation } from "@tanstack/react-query";
import { MdsLink } from "@/mds";
import { useCallback } from "react";

interface Props {
  chatConversationId: string;
  agentMode: boolean;
}

export function Error({ chatConversationId, agentMode }: Props) {
  const mutation = useMutation({
    mutationFn: () =>
      api.post("/v2/chat-conversations/{chat_conversation_id}/retry", {
        params: {
          path: {
            chat_conversation_id: chatConversationId,
          },
        },
        body: {
          agent_mode: agentMode,
        },
      }),
  });

  const handlePress = useCallback(() => {
    mutation.mutate();
  }, [mutation]);

  return (
    <Wrapper>
      Error sending reply.{" "}
      {(mutation.isIdle || mutation.isError) && <MdsLink onPress={handlePress}>Retry</MdsLink>}
    </Wrapper>
  );
}

const Wrapper = styled.div(({ theme }) => ({
  fontSize: "15px", // following chat content font size
  color: theme.colors.grey.x500,
  lineHeight: theme.lineHeights.medium,
}));
